import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
//import MonitorPageView from '../views/MonitorPageView.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/monitor/:company',
    name: 'MonitorPageView',
    component: () => import('../views/MonitorPageView.vue'),
    beforeEnter: (to, from, next) => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      store.commit('SET_USER_OBJECT', userData);
      if(userData && userData.roles.length > 0)
        next()
      else
        next('/login')
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPageView.vue'),
    beforeEnter: (to, from, next) => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      store.commit('SET_USER_OBJECT', userData);
      if(userData && userData.roles.length > 0)
        next('/monitor/web')
      else
        next()
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   if(to.name == 'MonitorPageView') {
//     if(!userData) {
//       next({name:'Login'})
//     }
//   } else {
//     next()
//   }
// })

export default router
